import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Reward from "./tabs/Reward";
import { Wrapper } from "../styled";

const incentiveTabs = [
{
    title: "Поощрения",
    component: <Reward/>,
}
];

const Incentives: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {incentiveTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {incentiveTabs[tab].component}
    </Wrapper>
);
};

export default Incentives;
